


export enum TableMigrationStatusEnum {
    OPEN = 0,
    PROGRESS = 1,
    COMPLETED = 2,
    FAILED = 99
}
